import React from 'react';
import testBonusOrders from './testBonusOrders';
import decl from '../../helpers/decl';

export default class BonusHistory extends React.Component {
  state = {
    orders: [],
    isLoading: true,
    btnShowMore: false,
    ordersList: [],
    ordersIsEmpty: true,
  };

  async componentDidMount() {
    const orders = await this.getData();
    if (!orders.length) {
      this.setState({
        isLoading: false,
      });
      return;
    }

    const ordersFilter = [...orders.filter(order => order.amount.bonus_add)];

    if (ordersFilter.length <= 0) {
      this.setState({
        isLoading: false,
      });
      return;
    }

    if (ordersFilter.length > 3) {
      this.setState({
        orders: ordersFilter.slice(3),
        isLoading: false,
        ordersList: ordersFilter.slice(0, 3),
        ordersIsEmpty: false,
        btnShowMore: true,
      });
      return;
    }

    if (ordersFilter.length <= 3) {
      this.setState({
        isLoading: false,
        ordersList: ordersFilter.slice(0, 3),
        ordersIsEmpty: false,
        btnShowMore: false,
      });
      return;
    }
  }

  getOrdersOffset = offset => {
    const orders = this.state.orders;
    if (orders.length > offset) {
      this.setState({
        ordersList: [...this.state.ordersList, ...orders.slice(0, offset)],
        orders: orders.slice(offset),
        btnShowMore: true,
      });
      return;
    }
    this.setState({
      ordersList: [...this.state.ordersList, ...orders.slice(0, offset)],
      btnShowMore: false,
    });
  };

  getData = async () => {
    try {
      const route = '/local/php_interface/api/v2/user/find_user_orders/';
      const response = await fetch(route);
      const data = await response.json();
      // const data = await testBonusOrders;
      return data ? data : [];
    } catch (error) {
      throw new Error(error);
    }
  };

  noBonusCard = () => {
    return (
      <div className="page-section__block">
        <div className="page-section__title">
          <h2 className="heading heading--1" style={{ opacity: 0.4 }}>
            История начислений
          </h2>
        </div>
        <div className="order-wrap">
          <div className="timeline-notfull timeline-notfull--bonus-history">
            <img src={lock} alt="" />
            <p className="timeline-notfull__descr">
              История начислений бонусов станет доступна, после активации
              бонусной карты
            </p>
          </div>
        </div>
      </div>
    );
  };

  bonusInApp = () => {
    return (
      <div className="page-section__block">
        <div className="page-section__title">
          <h2 className="heading heading--1" style={{ opacity: 0.4 }}>
            История начислений
          </h2>
        </div>
        <div className="order-wrap">
          <div className="timeline-notfull timeline-notfull--bonus-history">
            <img src={lock} alt="" />
            <p className="timeline-notfull__descr">
              История начисления бонусов доступна в приложении
            </p>
          </div>
        </div>
      </div>
    );
  };

  formatDate = date => {
    const monthNames = [
      'Января',
      'Февраля',
      'Марта',
      'Апреля',
      'Мая',
      'Июня',
      'Июля',
      'Августа',
      'Сентября',
      'Октября',
      'Ноября',
      'Декабря',
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const hour = date.getHours();
    const minutes = date.getMinutes();
    const month = monthNames[monthIndex];

    return `${day} ${month} ${year}, ${hour}:${minutes}`;
  };

  render() {
    const { ordersList, isLoading, btnShowMore, ordersIsEmpty } = this.state;
    if (isLoading) {
      return null;
    }

    if (ordersIsEmpty) {
      return (
        <div className="page-section__block--bonus-history">
          <div className="page-section__title">
            <h2 className="heading heading--1" style={{ opacity: 0.4 }}>
              История начислений
            </h2>
          </div>
          <div className="order-wrap">
            <div className="timeline-notfull timeline-notfull--bonus-history">
              <img
                src="/local/templates/comfortkino/static/img/lock.svg"
                alt=""
              />
              <p className="timeline-notfull__descr timeline-notfull__descr--nobonus">
                История начислений бонусов станет доступна, после следующей
                покупки
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="page-section__block--bonus-history">
        <div className="page-section__title">
          <h2 className="heading heading--1">История начислений</h2>
        </div>
        <div className="order-wrap">
          <div className="order order--bonus-history">
            {ordersList.map((order, index) => (
              <div key={index} className="order__body">
                <div className="order__poster">
                  <div
                    className="poster poster--order"
                    style={{
                      backgroundImage: `url(${order.film.poster.small})`,
                    }}
                  >
                    {/* <a href="/" className="poster__body"></a> */}
                    <p className="poster__body"></p>
                  </div>
                </div>
                <div className="order__content">
                  <div className="order__content__wrap">
                    <div className="order__block">
                      <h4 className="order__title">{order.film.name}</h4>
                      <div className="order__details">
                        <span className="order__date">
                          {this.formatDate(new Date(order.created_at))}
                        </span>
                        <p>#{order.number}</p>
                      </div>
                    </div>
                    <div className="order__units">
                      <div className="order__units__subtract">{`-${
                        order.amount.bonus_pay
                      } ${decl(order.amount.bonus_pay, [
                        'балл',
                        'балла',
                        'баллов',
                      ])}`}</div>
                      <div className="order__units__add">
                        <div className="order__units__add-green">
                          <span>+{order.amount.bonus_add}</span>
                        </div>
                        <span>Зачислено</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bonus-history__btn-wrap">
          <button
            className={btnShowMore ? 'btn btn--outline' : 'btn--none'}
            onClick={() => this.getOrdersOffset(3)}
          >
            Показать еще
          </button>
        </div>
      </div>
    );
  }
}
